import Store from '../store/Store';

export interface UploadFileParams {
	files: FileList;
	orderId: string;
	purpose: string;
	resultType: string;
	normalizedPurposes: Array<{ name: string; resultTypes: Array<{ name: string; id?: number }> }>;
}

export async function uploadFiles({
	files,
	orderId,
	purpose,
	resultType,
	normalizedPurposes,
}: UploadFileParams) {
	const url = Store.config.api.url + 'provider/upload';
	const currentUploads = (await Store.get().orderUploads) || [];
	let resultTypeId: number | undefined = undefined;

	const foundPurpose = normalizedPurposes.find((p) => p.name === purpose);

	if (foundPurpose) {
		const foundResultType = foundPurpose.resultTypes.find((rt) => rt.name === resultType);

		if (foundResultType && typeof foundResultType.id === 'number') {
			resultTypeId = foundResultType.id;
		}
	}

	if (resultTypeId === undefined) {
		console.error('GRESKA: Nije pronađen odgovarajući resultTypeId za', purpose, resultType);
		return;
	}

	const newUploads = Array.from(files).map((file) => ({
		_file: file,
		fileName: file.name,
		purpose,
		resultType,
		resultTypeId,
		total: 0,
		progress: 0,
	}));

	Store.set({
		orderUploads: [...currentUploads, ...newUploads],
	});

	newUploads.forEach((upload) => {
		const formData = new FormData();
		formData.append('file', upload._file);

		const metadata = {
			orderId,
			resultTypeId,
		};

		formData.append(
			'metadata',
			new Blob([JSON.stringify(metadata)], { type: 'application/json' })
		);

		console.log('SEND TO BE:', {
			fileName: upload.fileName,
			metadata,
		});

		const xhr = new XMLHttpRequest();
		xhr.open('POST', url);
		xhr.setRequestHeader('x-csrf-token', Store.token ?? '');
		xhr.withCredentials = true;

		xhr.upload.addEventListener('loadstart', ({ total }: { total: number }) => {
			upload.total = total;
			(upload as { _update?: () => void })._update?.();
		});

		xhr.upload.addEventListener(
			'progress',
			({ loaded, total }: { loaded: number; total: number }) => {
				upload.total = total;
				upload.progress = loaded / total;
				(upload as { _update?: (p: number) => void })._update?.(upload.progress);
			}
		);

		xhr.upload.addEventListener('loadend', () => {
			(upload as { _update?: (p: number | null) => void })._update?.(null);
		});

		xhr.send(formData);
	});
}
